import React from "react";
import * as Popover from "@radix-ui/react-popover";
import { cn } from "src/lib/cn";

interface EditPopoverProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: React.ReactNode;
  children: React.ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  align?: "start" | "center" | "end";
}

export function EditPopover({ open, onOpenChange, trigger, children, side = "bottom", align = "start" }: EditPopoverProps) {
  return (
    <Popover.Root
      open={open}
      onOpenChange={onOpenChange}
    >
      <Popover.Trigger asChild>{trigger}</Popover.Trigger>

      <Popover.Portal>
        <Popover.Content
          side={side}
          align={align}
          sideOffset={8}
          onOpenAutoFocus={(e) => e.preventDefault()}
          className={cn("z-[100] origin-top-left animate-flyout shadow-card bg-white overflow-hidden", "border border-gray-200 !rounded-xl", "min-w-[280px] max-w-[420px]")}
        >
          {children}
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
